// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-list__tile__content.AlignItemsCentre[data-v-87f6ae20]{align-items:center}.v-list.NoPaddingBottom[data-v-87f6ae20]{padding-bottom:0}.mark-as-read[data-v-87f6ae20]{cursor:pointer}.mark-as-read[data-v-87f6ae20]:hover{-webkit-text-decoration:underline;text-decoration:underline}.notification-list .v-list-item__subtitle[data-v-87f6ae20],.v-list-item__title[data-v-87f6ae20]{white-space:normal}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
